import { render, staticRenderFns } from "./ModelCard.vue?vue&type=template&id=794c9ac9&"
import script from "./ModelCard.vue?vue&type=script&lang=ts&"
export * from "./ModelCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCheckbox,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/builds/quebec-solidaire/qs_pointage_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('794c9ac9')) {
      api.createRecord('794c9ac9', component.options)
    } else {
      api.reload('794c9ac9', component.options)
    }
    module.hot.accept("./ModelCard.vue?vue&type=template&id=794c9ac9&", function () {
      api.rerender('794c9ac9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pointage/ModelCard.vue"
export default component.exports